import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

import Form from 'component/utils/Form'
import Modal from 'component/utils/Modal'
import _ from 'lodash'

const FIELDS = ['idSourceDepositList', 'idDestinationDepositList']

const MissionBlockEditModal = ({
  closeModal,
  depositList,
  missionList,
  updateAll,
  translate,
}) => {
  const [countDepositsSource, setCountDepositsSource] = useState({})
  const [countDepositsDestination, setCountDepositsDestination] = useState({})
  const [selectedMissionLists, setSelectedMissionList ] = useState([])
  const [disabled, setIsDisabled] = useState(true)
  useEffect(() => {
    const cloneMissionList = [...missionList].map(mission => ({...mission}))
    setSelectedMissionList(cloneMissionList)

  }, [])

  useEffect(() => {
    groupMissionsDeposits()
    isDisabled()
  }, [selectedMissionLists])
  const renderOptions = ( field, id) => {
    const renderOption = (deposit) => {
      const { idDeposit } = deposit
      let checkboxClassname = "stock-transfer-checkbox"

      const countObject = field === FIELDS[0] ? countDepositsSource :  countDepositsDestination
      const checked = Object.hasOwn(countObject, idDeposit)
      const count = countObject[idDeposit]
      if(count < missionList.length) checkboxClassname = "stock-transfer-checked-mid"
      return (
        <div className='stock-transfer-options' onClick={() =>
          !checked ? addMissionLists(field, deposit) : removeMissionLists(field,deposit)
        }>
          <label
          key={idDeposit}

          style={{ display: 'block', fontSize: '16px', lineHeight: '19px', color: checked ? 'black' : "#222020",  margin: '.5rem auto', fontWeight: checked ? 'bold' : 'normal' }}
        >
          {`${deposit.idDeposit} - ${deposit.dsDeposit}`}
        </label>
          <input className={`${checkboxClassname} margin-right`} type={"checkbox"} value={checked} checked={checked} />

        </div>

      )
    }

    return (
      <>
        <strong style={{ display: 'block', margin: '1rem auto', color: '#222020', fontSize: '16px', lineHeight: '19px' }}>
          {translate(`stockTransfer.missionBlock.${id}.old`)}
        </strong>
        {depositList.map(renderOption)}
      </>
    )
  }

  const groupMissionsDeposits = () => {

    const reduceDepositsSource = selectedMissionLists.reduce((missions, items) => {
        items.sourceDepositList.forEach((item) => {
            missions[item.idDeposit] = missions[item.idDeposit] || 0;
            missions[item.idDeposit]++
        })
        return missions
    }, {})

    const reduceDepositsDestination = selectedMissionLists.reduce((missions, items) => {
      items.destinationDepositList.forEach((item) => {
          missions[item.idDeposit] = missions[item.idDeposit] || 0;
          missions[item.idDeposit]++
      })
      return missions
  }, {})

    setCountDepositsSource(reduceDepositsSource)
    setCountDepositsDestination(reduceDepositsDestination)

  }

  const removeMissionLists = (field,deposit) => {
    const tempArray = JSON.parse(JSON.stringify(selectedMissionLists));
    tempArray.forEach((mission) => {
      if(field === FIELDS[0]){
        const deleteMission =  mission.sourceDepositList.findIndex(currentDeposit => currentDeposit.idDeposit === deposit.idDeposit)
        if(deleteMission >= 0) mission.sourceDepositList.splice(deleteMission, 1)

      }
      else {
        const deleteMission =  mission.destinationDepositList.findIndex(currentDeposit => currentDeposit.idDeposit === deposit.idDeposit)
        if(deleteMission >= 0) mission.destinationDepositList.splice(deleteMission, 1)
      }
    })
    setSelectedMissionList(tempArray)
  }
  const addMissionLists = (field,deposit) => {


    const tempArray = JSON.parse(JSON.stringify(selectedMissionLists));
    tempArray.forEach((mission) => {

       if(field === FIELDS[0]) {
          const hasExistDeposit = mission.sourceDepositList.filter(currentDeposit => currentDeposit.idDeposit === deposit.idDeposit).length > 0
          if(hasExistDeposit) return
          mission.sourceDepositList.push(deposit)
       }
       else {
          const hasExistDeposit = mission.destinationDepositList.filter(currentDeposit => currentDeposit.idDeposit === deposit.idDeposit).length > 0
          if(hasExistDeposit) return
          mission.destinationDepositList.push(deposit)
       }
    })
    setSelectedMissionList(tempArray)

}

  const isDisabled = () => {
    let sourceDisabled = true
    let destinationDisabled = true
    let anyChanged = false
    selectedMissionLists.forEach((mission,index) => {

     sourceDisabled = missionList[index].sourceDepositList.length === mission.sourceDepositList.length && _.isEqual(_.sortBy(missionList[index].sourceDepositList, (o) => o.idDeposit), _.sortBy(mission.sourceDepositList, (o) => o.idDeposit))
     destinationDisabled = missionList[index].destinationDepositList.length === mission.destinationDepositList.length && _.isEqual(_.sortBy(missionList[index].destinationDepositList, (o) => o.idDeposit), _.sortBy(mission.destinationDepositList, (o) => o.idDeposit))

     if((sourceDisabled && destinationDisabled) === false) {
        anyChanged  = true
     }
    })

    setIsDisabled(!anyChanged)
  }

  return (
    <Modal
      closeModal={closeModal}
      size='md'
      className='mission-block-edit-modal mission-edit-modal-new'
    >
      <h3 style={{fontSize: '24px'}}>
        <strong style={{color: 'black'}}>{translate("stockTransfer.missionBlock.modal.add.and.remove")}</strong>
      </h3>
      <p>
      <strong>{`${missionList.length} ${translate(
            `stockTransfer.missionBlock.selection.quantity${
              missionList.length > 1 ? 'Plural' : 'Singular'
            }`
          )}`}</strong>
      </p>
      <p>
        <span style={{color: '#222020', fontSize: '16px'}}  >{translate('stockTransfer.missionBlock.modal.text')}</span>
      </p>
      <section style={{ display: 'grid', gridTemplateColumns: '1fr 1fr' }}>
        <div>
          {renderOptions(

            'idSourceDepositList',
            'source'
          )}
        </div>
        <div>
          {renderOptions(

            'idDestinationDepositList',
            'destination'
          )}
        </div>
      </section>
      <div className='mission-block-new-modal-actions'>

        <button
          disabled={disabled}
          onClick={() => updateAll(selectedMissionLists)}
          className='mission-save'
        >
          {translate('save_button_label')}
        </button>

        <button
          onClick={() => closeModal()}
          className='mission-cancel'
        >
        {translate('cancel_button')}
        </button>


      </div>
    </Modal>
  )
}

MissionBlockEditModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  depositList: PropTypes.array.isRequired,
  fields: PropTypes.object.isRequired,
  initialValues: PropTypes.object.isRequired,
  setValueToField: PropTypes.func.isRequired,
  submit: PropTypes.func.isRequired,
  translate: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
  missionList: PropTypes.array.isRequired,
  updateMissionsLists: PropTypes.func.isRequired,
  updateAll: PropTypes.func.isRequired
}

export default Form({ fields: FIELDS })(MissionBlockEditModal)

export { MissionBlockEditModal }
